<app-card [showHeader]="false" cardClass="user-card" padding="20">
  <div class="flex align-items-center">
    <div class="flex-shrink-0">
      @if (profileImage) {
        <img [src]="profileImage" alt="user-image" style="width: 50px; height: 50px; border-radius: 50%" />
      } @else {
        <img src="assets/images/user-placeholder.png" alt="user-image" style="width: 50px; height: 50px" />
      }
    </div>
    <div class="flex-grow-1 user-details">
      <div class="f-w-600 f-16">{{ currentLang == 'ar' ? empDetails?.empfullaraname : empDetails?.empfulllatname }}</div>
      <div class="mat-caption f-w-500 text-muted f-14">{{
        currentLang == 'ar' ? empDetails?.empjob.jobaraname : empDetails?.empjob.joblatname
      }}</div>
    </div>
    <app-user-setting></app-user-setting>
  </div>
  <div class="flex pt-3">
    <div class="">
      <div class="f-w-500 text-muted f-14"> {{ branch$ | async}}</div>
      <div class="mat-caption f-w-600 text-dark f-14">{{
        currentLang == 'ar' ? empDetails?.empbranch.brancharaname : empDetails?.empbranch.branchlatname
      }}</div>
    </div>
    <div class="px-3"> </div>

    <mat-divider [vertical]="true"></mat-divider>
    <div class="px-3"> </div>
    <div class="">
      <div class="f-w-500 text-muted f-14"> {{ department$ | async }}</div>
      <div class="mat-caption f-w-600 text-dark f-14">{{
        currentLang == 'ar' ? empDetails?.empdepartment.deparaname : empDetails?.empdepartment.deplatname
      }}</div>
    </div></div
  >
</app-card>
